<template>
  <v-alert
    v-if="visible"
    color="#e3f2fd"
    border="left"
    elevation="2"
    class="audit-report-notice mb-5"
  >
    <v-icon color="#1565c0" class="mr-2">mdi-information</v-icon>
    สามารถดูรายงานการแก้ไขเอกสารได้ที่ เมนู &gt; รายงาน &gt;
    <router-link
      :to="{ name: 'report-edit-document' }"
      class="audit-report-link"
    >
      การแก้ไขเอกสาร
    </router-link>
  </v-alert>
</template>

<script>
const NOTICE_STORAGE_KEY = 'quotation-audit-report-notice-started-at';
const NOTICE_DURATION = 7 * 24 * 60 * 60 * 1000;
const NOTICE_END_AT = new Date('2026-09-21T23:59:59+07:00').getTime();

export default {
  data: () => ({
    visible: false,
  }),
  watch: {
    '$store.state.profile.user_type': {
      immediate: true,
      handler() {
        this.updateVisibility();
      },
    },
  },
  methods: {
    updateVisibility() {
      if (this.$store.state.profile.user_type !== 'owner') {
        this.visible = false;
        return;
      }

      let startedAt = Number(localStorage.getItem(NOTICE_STORAGE_KEY));
      if (!startedAt) {
        startedAt = Date.now();
        localStorage.setItem(NOTICE_STORAGE_KEY, String(startedAt));
      }

      const now = Date.now();
      this.visible =
        now - startedAt < NOTICE_DURATION && now <= NOTICE_END_AT;
    },
  },
};
</script>

<style scoped>
.audit-report-notice {
  color: #0d47a1;
  font-weight: 500;
}

.audit-report-link {
  color: #0d47a1;
  font-weight: 700;
  text-decoration: underline;
}
</style>
